var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlert16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C15.9949616,12.4161893 12.4161893,15.9949616 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1.14285714 C4.21290457,1.14285714 1.14285714,4.21290457 1.14285714,8 C1.14285714,11.7870954 4.21290457,14.8571429 8,14.8571429 C11.7870954,14.8571429 14.8571429,11.7870954 14.8571429,8 C14.8530487,4.21460174 11.7853983,1.14695134 8,1.14285714 Z M7.99257143,10.5 C8.623754,10.5 9.13542857,11.0116746 9.13542857,11.6428571 C9.13542857,12.2740397 8.623754,12.7857143 7.99257143,12.7857143 C7.36138886,12.7857143 6.84971429,12.2740397 6.84971429,11.6428571 C6.84971429,11.0116746 7.36138886,10.5 7.99257143,10.5 Z M7.99285714,3.19742857 C8.53078249,3.19742857 8.96685714,3.63350323 8.96685714,4.17142857 L8.77485714,9.12228571 C8.79250817,9.41544697 8.64613223,9.69421718 8.39478188,9.8461319 C8.14343153,9.99804662 7.82856847,9.99804662 7.57721812,9.8461319 C7.32586777,9.69421718 7.17949183,9.41544697 7.19714286,9.12228571 L7.01885714,4.17142857 C7.01885714,3.63350323 7.4549318,3.19742857 7.99285714,3.19742857 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#C73500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlert16);
export default __webpack_public_path__ + "static/media/messageAlert16.b6d40cecb628e5a1a5935a2c4dc41c31.svg";
export { ForwardRef as ReactComponent };